import {Component, OnDestroy, OnInit} from '@angular/core';
import {BroadcastsService} from "../../services/broadcasts.service";
import {ActivatedRoute} from "@angular/router";
import {Observable, Subscription} from "rxjs";
import {take} from "rxjs/operators";
import {BroadcastLayerModule} from "../broadcast-layer.module";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-user-output',
  templateUrl: './user-output.component.html',
  styleUrls: ['./user-output.component.scss'],
  imports: [
    BroadcastLayerModule,
    NgIf
  ],
  standalone: true
})
export class UserOutputComponent implements OnInit, OnDestroy {

  public broadcastUid: string;
  private subscription: Subscription;

  constructor(
    private route: ActivatedRoute,
    private broadcastService: BroadcastsService,
  ) { }

  ngOnInit(): void {
    const userUid: string = this.route.snapshot.paramMap.get('user-uid');
    this.subscription = this.broadcastService.getLinkedBroadcastUid(userUid).subscribe(linkedBroadcastUid => {
      this.broadcastUid = linkedBroadcastUid;
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

}
